<script setup>
//import { useUserStore } from "@/stores/UserStore"

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

// const userStore = useUserStore()
//
// onMounted(async () => {
//   if(isEmpty(userStore.currentUser?.employeeId)){
//     await userStore.getCurrentUserInfo()
//     // setTimeout(async () => {
//     //   await userStore.getCurrentUserInfo()
//     // }, 50)
//   }
// })



</script>

<template>

  <VRow
    no-gutters
    class="auth-wrapper"
  >
    <VCol
      cols="12"
      class="d-none d-md-flex align-center justify-center position-relative"
    >
      <div>Trwa przekierowanie... TEST</div>
    </VCol>

  </VRow>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth";
</style>
